export default "__VITE_ASSET__C6xWchB4__"